import React from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import { TransactionAccountProduct } from '@css-xp/graphtypes/src/generated-types-new';
import './apps-count.scss';

export const getAppCount = (subscription: TransactionAccountProduct) => {
  return subscription?.linkedAppsId?.length ?? 0;
};

export interface AppsCountCellProps {
  subscription?: TransactionAccountProduct;
  baseRoute?: string;
  version?: number;
  subscriptionId?: string;
  appsCount?: number;
}

export const AppsCountCell = ({ subscription, baseRoute, version, subscriptionId, appsCount }: AppsCountCellProps) => {
  const count = appsCount ? appsCount : getAppCount(subscription as TransactionAccountProduct);
  const id = subscriptionId ? subscriptionId : subscription?.id;

  return (
    <td className="apps-count-container">
      <Link to={baseRoute ? `${baseRoute}${id}#apps` : ''}>
        <span
          className={classNames({ 'apps-count-cell-empty': count === 0 }, 'apps-count-cell', {
            'apps-count-cell-v2': version === 2,
          })}
        >
          {version === 2 && !count ? '-' : count}
        </span>
      </Link>
    </td>
  );
};
